<!-- 辅助文档- -->
<template>
  <div class="help-right">
    <div class="left"></div>
    <div class="mid">
      <a id="event_1"></a>
      <div class="content">
        <div class="section">
          <h1>
            <a id="event_2" href="#标题一" class="header-anchor">#</a>小智编辑器介绍
          </h1>
          <br/>
          <!-- <h2>
            <a href class="header-anchor">#</a> Python介绍
          </h2> -->
          <p>
            小智编辑器是配套小智AI机器人的专用编辑器，通过可视化-积木式的编程，以“拖拉拽”的方式地拼搭功能积木，配合小智AI机器人地车体、多轴机械臂和软体手，可实现图案识别与定位、智能抓取、物体识别、物品搬运、人脸识别、智能避障等功能。此外，小智AI机器人还具备丰富的软硬件拓展性，支持自主外接传感器等多种电子硬件，支持灵活搭建丰富的结构组件；可实现行业应用场景搭建及项目模拟创研，将AI理论知识与实操应用有效结合。
          </p>
        </div>

        <!-- <div class="section">
          <a style="margin-bottom:100px;"></a>
          <h2>
            <a id="event_3" href="" class="header-anchor">#</a>
             认识编辑器
          </h2>
          <p>
            国匠云为人工智能初学者专门提供了AI Training编辑器，无需安装任何环境，可直接在云端进行运行，并展示计算的结果和图形，有效降低了大家学习Python的门槛，通过搭积木和人性化的交互方式提高了初学者的学习积极性。让我们先来简单认识下AI Training编辑器吧！
          </p>
          <p>
            AI Training主要分为四大区域，积木分类区、编程区、终端区和绘图区，同时还拥有双模式（积木模式和查看代码），支持通过搭积木的方式写出Python代码，完成有独创的Python图形化编程，也可快速切换查看积木程序对应的Python代码。
          </p>
          <div>
            <img src="../../../assets/images/HelpDocument/aiIntroduce-image.png" alt="开始进入" />
          </div>
          <p>
            积木分类区：对积木元素进行分类，主要按照事件、控制、运算、类型、变量等划分，积木元素可通过拖拉拽的方式移动至编辑区。
          </p>
          <p>
            编程区：通过积木/查看代码编写Python程序。
          </p>
          <p>
            终端区：点击“运行”显示编程区运行后的结果，点击“清除”可清空所有运行记录。
          </p>
          <p>
            绘图区：展示运行后的图形效果。
          </p>
 
        </div> -->

        <!-- <div class="section">
          <h2>
            <a id="event_4" href="" class="header-anchor">#</a> 在线运行代码
          </h2>
          <p>
            无需安装任何环境，直接打开网页就可以在AI Training编辑器以搭积木形式编写Python代码，并在线运行显示出结果和图形。
          </p>
          <p>
            <strong>AI Training编辑器目前支持在线运行的库包括：</strong>
          </p>
          <p>
            <ul>
              <li>math</li>
              <li>random</li>
              <li>turtle</li>
              <li>time (partial)</li>
              <li>random (partial)</li>
              <li>urllib (partial)</li>
              <li>unittest</li>
              <li>image</li>
              <li>DOM (partial)</li>
              <li>re (partial)</li>
            </ul>
          </p>
        </div> -->

        <!-- <div class="section">
          <h2>
            <a id="event_5" href="" class="header-anchor">#</a> 积木/代码模式切换
          </h2>
          <p>
            AI Training编辑器可以自由切换代码、积木两种模式，“积木编程”即系统内置把一些基本的Python代码转换成各种类型的积木，用户只需通过“拖拉拽”的方式拼接功能积木，快速搭建项目，从而达到学习Python的目的；“查看代码”即可以快速查看当前项目的积木程序对应的Python代码。
          </p>
          <p>在【积木编程】完成程序拼搭后，点击【查看代码】按钮将积木转换成真正的Python语言。</p>
          <p>
            <img
              src="../../../assets/images/HelpDocument/image1.2.1.png"
              alt="开始进入"
            />
          </p>
        </div> -->
        
        <div class="section"></div>
      </div>
    </div>

    <!-- 右侧菜单导航 -->
    <div class="navs">
      <span @click="toTop">{{ rightnavs }}</span>
      <ul class="drop">
        <li
          :class="{ active: active === index }"
          v-for="(item, index) in rightdropnavs.Items"
          :key="index"
          @click="onScrollTop(index)"
        >
          <a href="javascript:;">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import GatFooter from "@/components/common/GatFooter.vue";

export default {
  name: 'AiIntroducePage',
  props: {
    hashId: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      active: 0, // 当前激活的导航索引
      scrollTop: 0,
      rightnavs: '小智编辑器介绍',
      rightdropnavs: {
        Items: [
          // {
          //   title: ' Python介绍',
          // },
          // {
          //   title: ' 小智编辑器介绍',
          // },
          // {
          //   title: ' 在线运行代码',
          // },
          // {
          //   title: ' 代码/积木模式切换',
          // }
        ],
      },
    }
  },
  created() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    // 积木跳转过来触发事件锚点位置
    if (this.hashId !== 0) {
      setTimeout(()=>{
        this.onScrollTop(this.hashId - 1)
      }, 200)
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll, false)
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll('.content .section')
      // 所有锚点元素的 offsetTop
      const offsetTopArr = []
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop)
      })
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 定义当前点亮的导航下标
      let navIndex = 0
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop + 160 >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      this.active = navIndex
    },
    // 跳转到指定索引的元素
    onScrollTop(index) {
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      const targetOffsetTop = document.querySelector(
        `.content .section:nth-child(${index + 1})`
      ).offsetTop
      // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉
      const STEP = 50
      // 判断是往下滑还是往上滑
      if (scrollTop + 160 > targetOffsetTop) {
        // 往上滑
        smoothUp()
      } else {
        // 往下滑
        smoothDown()
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop - 100
          document.documentElement.scrollTop = scrollTop - 100
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown)
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop - 100
          document.documentElement.scrollTop = scrollTop - 100
          requestAnimationFrame(smoothUp)
        }
      }
    },
    toTop() {
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0
      } else {
        document.body.scrollTop = 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.help {
  &-left {
    position: fixed;
    width: 220px;
    height: 100%;
    margin-right: 10px;
    background: #fff;

    .title {
      line-height: 60px;
      font-size: 16px;
      color: #333;
      text-align: center;
    }
    .item {
      border-left: 3px solid transparent;
      text-indent: 17px;
      font-size: 14px;
      color: #333;
      line-height: 40px;
      cursor: pointer;
      &:hover,
      &.active {
        border-left: 3px solid #4c88ff;
        background: #dfeaff;
      }
    }
  }
  &-right {
    float: right;
    width: 970px;
    min-height: 780px;
    background: #fff;
    .left,
    .right,
    .mid {
      float: left;
      width: 14%;
      min-height: 20px;
    }
    .mid {
      width: 72%;
    }

    h1 {
      font-size: 2.2rem;
    }
    h2 {
      font-size: 1.65rem;
      padding-bottom: 0.3rem;
      border-bottom: 1px solid #eaecef;
    }
    p,
    ul {
      line-height: 1.7;
    }
    ul {
      padding-left: 1.2em;
    }
    strong {
      font-weight: 600;
    }
    .content pre,
    .content pre[class*='language-'] {
      background-color: #282c34;
      line-height: 1.4;
      border-radius: 6px;
      padding: 1.25rem 1.5rem;
      margin: 0.85rem 0;
      white-space: pre-wrap;
      word-break: break-word;
      overflow: auto;
      position: relative;
    }
    .content pre:before,
    .content pre[class*='language-']:before {
      position: absolute;
      top: 0.8em;
      right: 1em;
      font-size: 0.75rem;
      color: hsla(0, 0%, 100%, 0.4);
    }
    .content code {
      color: #476582;
      padding: 0.25rem 0.5rem;
      margin: 0;
      font-size: 0.85em;
      background-color: rgba(27, 31, 35, 0.05);
      border-radius: 3px;
    }
    .content pre[class*='language-'] code,
    .content pre code {
      color: #fff;
      padding: 0;
      background-color: transparent;
      border-radius: 0;
    }
    .token.comment,
    .token.doctype,
    .token.prolog {
      color: #999;
    }

    a.header-anchor {
      font-size: 0.85em;
      float: left;
      margin-left: -0.87em;
      padding-right: 0.23em;
      margin-top: 0.125em;
      opacity: 0;
    }
    .content:not(.custom) > h1,
    .content:not(.custom) > h2,
    .content:not(.custom) > h3,
    .content:not(.custom) > h4,
    .content:not(.custom) > h5,
    .content:not(.custom) > h6 {
      margin-top: -3.1rem;
      padding-top: 4.6rem;
      margin-bottom: 0;
    }
    p {
      margin: 1em 0;
    }
    ul {
      list-style-type: disc;
    }
    .toc-box,
    .toc-scroll-mask {
      bottom: 180px;
      position: fixed;
      right: 3.57%;
    }
    .table-of-contents.active {
      display: block;
      width: 200px;
    }
    .table-of-contents.active > ul {
      position: relative;
      margin-top: 0;
      padding-left: 0;
    }
    .table-of-contents.active > ul > li {
      position: relative;
    }
    .table-of-contents li {
      list-style: none;
    }
    .table-of-contents.active > ul > li:before {
      left: 15px;
      top: 14px;
      content: '';
      position: absolute;
      width: 1px;
      height: 100%;
      background-color: #eaecef;
    }
    .table-of-contents.active > ul > li > a {
      font-size: 16px;
      margin-left: 32px;
      color: #333;
    }
    .table-of-contents.active > ul > li > ul {
      position: relative;
      max-height: 300px;
      padding-left: 32px;
    }
    .table-of-contents.active > ul > li > ul > li {
      position: relative;
      white-space: nowrap;
    }
    .table-of-contents > ul > li > ul > li.active a {
      color: $bgc_btn_primary;
    }
    .table-of-contents.active > ul > li > ul > li:after {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: $bgc_btn_primary;
      left: -21px;
      top: 50%;
      margin-top: -2px;
      display: none;
    }
    .table-of-contents.active > ul > li.active:after,
    .table-of-contents.active > ul > li > ul > li.active:after {
      display: block;
    }
    .table-of-contents.active > ul:before {
      left: 9px;
      top: 12px;
    }
    .table-of-contents.active a {
      font-size: 14px;
      color: #666;
    }
    .table-of-contents.active > ul:after,
    .table-of-contents.active > ul:before {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 2px solid #eaecef;
      background-color: #fff;
      z-index: 10;
    }
    .table-of-contents.active > ul:after {
      left: 9px;
      top: 100%;
      margin-top: 5px;
    }
    code,
    kbd {
      font-family: source-code-pro, Menlo, Monaco, Consolas, Courier New,
        monospace;
    }
    ul ul {
      list-style-type: circle;
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
  }
}
.gat-head {
  width: 100%;
  // position: fixed !important;
  top: 0;
  z-index: 3;
  box-sizing: border-box;
}

.clearfix:after {
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
  content: '';
}

.navs {
  position: fixed;
  bottom: 80px;
  right: 2%;
  &:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #eaecef;
    background-color: #fff;
    z-index: 10;
    left: -12px;
    top: 9px;
  }
  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #eaecef;
    background-color: #fff;
    z-index: 10;
    left: -12px;
    top: 100%;
    margin-top: 5px;
  }
  .drop {
    list-style: none;
    padding-left: 0;
  }
  span {
    padding-left: 15px;
    cursor: pointer;
    color: #333;
  }
}

.drop li {
  position: relative;
  padding-left: 15px;
  &:before {
    left: -7px;
    top: 0px;
    content: '';
    position: absolute;
    width: 1px;
    height: 120%;
    background-color: #eaecef;
  }
  a {
    font-size: 14px;
    color: #666;
  }
}
.drop li.active {
  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: $bgc_btn_primary;
    left: -10px;
    top: 50%;
    margin-top: -5px;
  }
  a {
    color: $bgc_btn_primary;
    border-color: $bgc_btn_primary;
  }
}
.help-right .content {
  padding: 50px 0;
  .section {
    // min-height: 340px;
    margin-bottom: 30px;
    p {
      text-indent: 2em;
    }
  }
  .section:last-child {
    min-height: 55vh;
  }
}
.help-left .item {
  a {
    color: #2c3e50;
  }
}
</style>
